<div class="b-title b-title__iconed-search b-title__iconed p-hotels-title"
     style="border: 0;">
    <div class="b-title-text">
        {{ messages.searchResultText }} / {{ messages.foundText }}:
        <span class="p-hotels-value">
            <span *ngIf="toursCount$ | async as tourCount">
             {{tourCount}} {{ tourTotal(tourCount) }}
            </span>
            <span *ngIf="(firstToursFound$ | async) === false"><img src="/img/icons/hottable/loading.svg" /></span>
        </span>
    </div>
    <div class="b-title-hint font-opensans">{{ info }}</div>
    <div class="clearfix"></div>
</div>

<div class="ng-search-progress-container">
    <app-search-progress *ngIf="showSearchProgress"
                         [animationDuration]="searchProgressTimeout"></app-search-progress>
</div>

<app-tour-include [isTight]="true"></app-tour-include>
